import React, { Component } from 'react'
import {
    Tooltip
} from 'reactstrap';
import { Link } from 'react-router-dom';

class ActionsRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            TooltipDelete: false,
            TooltipApprove: false
        };
    }
    toggleTooltipDelete() {
        this.setState({
            TooltipDelete: !this.state.TooltipDelete
        });
    }
    toggleTooltipApprove() {
        this.setState({
            TooltipApprove: !this.state.TooltipApprove
        });
    }
    actionApprove(){
        this.props.actionApprove(this.props.clientId)
    }
    actionDelete(){
        this.props.actionDelete(this.props.clientId)
    }
    render(){
        return(
            <div className="btn-group btn-group-sm actions-row" role="group">
                <button
                    id={"TooltipDelete_" + this.props.clientId}
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={this.actionDelete.bind(this)}
                >
                    <i className="fa fa-remove" />
                    <Tooltip
                        placement="top"
                        isOpen={this.state.TooltipDelete}
                        target={"TooltipDelete_" + this.props.clientId}
                        toggle={this.toggleTooltipDelete.bind(this)}
                    >
                        Borrar usuario
                    </Tooltip>
                </button>
                {Number(this.props.approved) === 0 &&
                    <button
                        id={"TooltipApprove_" + this.props.clientId}
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={this.actionApprove.bind(this)}
                    >
                        <i className="fa fa-check" />
                        <Tooltip
                            placement="top"
                            isOpen={this.state.TooltipApprove}
                            target={"TooltipApprove_" + this.props.clientId}
                            toggle={this.toggleTooltipApprove.bind(this)}
                        >
                            Aprovar usuario
                        </Tooltip>
                    </button>
                }
            </div>
        )
    }
}
export default ActionsRow


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/clients/ActionsRow.jsx